__turbopack_context__.v({
  "best-value": "RefundOptions-module-scss-module__v8sZSG__best-value",
  "refund-option": "RefundOptions-module-scss-module__v8sZSG__refund-option",
  "refund-option-checkbox": "RefundOptions-module-scss-module__v8sZSG__refund-option-checkbox",
  "refund-option-divider": "RefundOptions-module-scss-module__v8sZSG__refund-option-divider",
  "refund-option-title": "RefundOptions-module-scss-module__v8sZSG__refund-option-title",
  "refund-options": "RefundOptions-module-scss-module__v8sZSG__refund-options",
  "refund-options-brand-opacity": "RefundOptions-module-scss-module__v8sZSG__refund-options-brand-opacity",
  "refund-options-subtitle": "RefundOptions-module-scss-module__v8sZSG__refund-options-subtitle",
});
